import type { TableView } from "owa-mail-list-store";
import { mutatorAction } from "satcheljs";

const setFocusedRowKeyMutator: (tableView: TableView, focusedRowKey: string | null) => void = mutatorAction("setFocusedRowKey", function setFocusedRowKey(tableView: TableView, focusedRowKey: string | null): void {
    tableView.focusedRowKey = focusedRowKey;
});
export default setFocusedRowKeyMutator;
